import { render } from "./MailReader.vue?vue&type=template&id=3297cfc0&scoped=true"
import script from "./MailReader.vue?vue&type=script&lang=js"
export * from "./MailReader.vue?vue&type=script&lang=js"

import "./MailReader.vue?vue&type=style&index=0&id=3297cfc0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3297cfc0"]])

export default __exports__